import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const COLOR_OPTIONS = [
  { value: "#E8A030", label: "Gold" },
  { value: "#7AB8A0", label: "Sage" },
  { value: "#A08CC8", label: "Violet" },
  { value: "#C86F3C", label: "Copper" },
  { value: "#6AABB8", label: "Teal" },
  { value: "#E87070", label: "Rose" },
  { value: "#4A7A5A", label: "Forest" },
  { value: "#8C7A5A", label: "Stone" },
];

export const CollectionModal = ({
  open, onOpenChange, editing, form, setForm,
  onSave,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="modal-dark sm:max-w-md">
      <DialogHeader>
        <DialogTitle className="font-serif text-[#FDF8EE]">{editing ? "Edit Volume" : "Create Volume"}</DialogTitle>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div>
          <label className="font-mono text-[9px] text-[#4A3A1A] uppercase tracking-[1px] block mb-1.5">Name</label>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="e.g., Investor Pitch Materials" className="input-dark w-full" data-testid="collection-name-input" />
        </div>
        <div>
          <label className="font-mono text-[9px] text-[#4A3A1A] uppercase tracking-[1px] block mb-1.5">Description</label>
          <textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} placeholder="Brief description..." className="input-dark w-full resize-none" rows={2} data-testid="collection-description-input" />
        </div>
        <div>
          <label className="font-mono text-[9px] text-[#4A3A1A] uppercase tracking-[1px] block mb-1.5">Color</label>
          <div className="flex gap-2">
            {COLOR_OPTIONS.map((color) => (
              <button key={color.value} onClick={() => setForm({ ...form, color: color.value })} className={`w-8 h-8 transition-all ${form.color === color.value ? 'ring-2 ring-offset-2 ring-offset-[#1C1004] ring-[#FDF8EE]' : ''}`} style={{ backgroundColor: color.value }} title={color.label} />
            ))}
          </div>
        </div>
      </div>
      <DialogFooter>
        <button onClick={() => onOpenChange(false)} className="btn-ghost">Cancel</button>
        <button onClick={onSave} disabled={!form.name.trim()} className="btn-primary" data-testid="save-collection-btn">{editing ? "Save" : "Create"}</button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
